import { format } from 'date-fns';

// Characters Windows or macOS refuse in a file name.
const FORBIDDEN_FILE_NAME_CHARACTERS = /[\\/:*?"<>|]/g;

/**
 * Builds a download name like `Share Register - AX VII NTG Holding II AB (2026-09-23).pdf`,
 * keeping the subject's casing and non-ASCII letters (å, ä, ö).
 */
export const buildExportFileName = (
	documentType: string,
	subject: string | undefined,
	date: Date,
	extension: string
): string => {
	const safeSubject = subject?.replace(FORBIDDEN_FILE_NAME_CHARACTERS, '-').trim();
	const title = safeSubject ? `${documentType} - ${safeSubject}` : documentType;

	return `${title} (${format(date, 'yyyy-MM-dd')}).${extension}`;
};
